import Header from './components/Header';
import HeroSection from './components/HeroSection';
import CarouselSection from './components/CarouselSection';
import ContactSection from './components/ContactSection';
import FeaturesSection from './components/FeaturesSection';
import CardsSection from './components/CardsSection';
import RankingSection from './components/RankingSection';
import AboutSection from './components/AboutSection';
import CommentsSection from './components/CommentsSection';
import TopicsSection from './components/TopicsSection';
import FaqSection from './components/FaqSection';
import UpdatesSection from './components/UpdatesSection';
import IndexSection from './components/IndexSection';
import MediaSection from './components/MediaSection';
import AppSection from './components/AppSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <CarouselSection />
        <ContactSection />
        <FeaturesSection />
        <CardsSection />
        <RankingSection />
        <AboutSection />
        <CommentsSection />
        <TopicsSection />
        <FaqSection />
        <UpdatesSection />
        <IndexSection />
        <MediaSection />
        <AppSection />
      </main>
      <Footer />
    </>
  );
}